module.exports = __webpack_public_path__ + "img/hzfp36.736f8485.png";